module.exports = __webpack_public_path__ + "img/Widget_card_headpics_SB_storyboard.ef680ca3.jpg";